/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { InlineMessage, Group, Title, DayPickerDropDown, SelectableList } from '@insticator/insticator-ui'; // iui-materials
import Area from 'pages/dashboard/reports/detail/area/area';
import AddableEmailList from 'material/addableemaillist/addableemaillist_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/detail/schedule/schedule_styles';



/* ========== ~~~~~~~~~~ REPORT SCHEDULE ~~~~~~~~~~ ========== */
class ReportSchedule extends Component {
    constructor(props) {
    	super(props);
		this.emailListDiv = null;
	}

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.emails.length !== this.props.emails.length) {
            this.adjustScrollTopEmailList();
        }

		// Make sure 'Once' option is selected if user chooses Custom Date Range.
		// All of the other options are disabled if Custom Date Range is selected.
        if(this.props.dateRange === 'CUSTOM' && this.props.dateRange !== prevProps.dateRange && !this.props.isReportSaved) {
            this.handleScheduleType('ONCE');
        }
    }

	renderScheduleTypeList = () => (
		<div className={`schedule-type`}>
			<Title size={`small`}>
				<h2>Run this report</h2>
			</Title>
			<SelectableList type='radio'
				  items = {[{ value: 'ONCE', text: `Once (don't schedule it)`},
					  { value: 'DAILY', text: 'Daily' },
					  { value: 'WEEKLY', text: 'Weekly' },
					  { value: 'MONTHLY', text: 'Monthly' }]}
				  disabled={this.props.dateRange === 'CUSTOM' ? ['DAILY', 'WEEKLY', 'MONTHLY'] : null} // Disable all options except for 'ONCE' for custom date range reports.
				  selected={this.props.schedule}
				  handleChange = {(value) => this.handleScheduleType(value)} />
		</div>
	);

    handleScheduleType = (value) => {
		this.props.setReportProperties({schedule: value});
		if(value === 'ONCE') {
			this.props.setReportProperties({emails: []});
			//we need an endDate or the ppa call will fail 🤯
			//this.props.setReportProperties({endDate: ""});
		}
	};

    renderScheduleOptionList = () => (
		<Group klass = {'schedule_options'} direction={`vertical`}>
			<InlineMessage variant={`neutral`} size={`full`} icon={`exclamation-triangle`} message={this.getScheduleMessageText()} />
			<Group direction={`horizontal`}>
				{this.renderEndDate()}
				{this.renderEmailList()}
			</Group>
		</Group>
	);

	getScheduleMessageText = () => {
		switch (this.props.schedule){
			case 'MONTHLY':
				return 'Reports are sent on the first day of every month at 5:30pm EST';
			case 'WEEKLY':
				return 'Reports are sent every Monday at 5:30pm EST';
			case 'DAILY':
			default:
			  return 'Reports are sent daily at 5:30pm EST';
		}
	};

	renderEndDate = () => (
		<div className={`enddate`}>
			<Title size={`small`}>
				<h4>Select an end date</h4>
			</Title>
			<DayPickerDropDown selectedDay={this.props.endDate} disabledDates={[{before: new Date()}]} selectDay={day=>this.props.setReportProperties({endDate: day})}/>
		</div>
	);

	// Every time a new email field is added, this will adjust the scroll top in such a way that the "Add new email" button is always visible to the user.
	adjustScrollTopEmailList = () => {
		if(this.emailListDiv) {
			this.emailListDiv.scrollTop = this.emailListDiv.scrollHeight;
		}
	};

	handleAddEmail = (value) => {
		let emails = [...this.props.emails];
		emails.push(value);
		this.props.setReportProperties({emails: emails});
	};

	handleEmailValidityCheck = (emails) => {
		let scheduleValid = true;
		emails.forEach((item) => {
			if(!item.valid) {
				scheduleValid = false;
				item.valid = !!item.valid;
			}
		});
		this.props.setReportProperties({selectedReportDataValid: {...this.props.selectedReportDataValid, schedule: scheduleValid}});
	};

	handleRemoveEmail = (index) => {
		let emails = this.props.emails.filter((val , idx) => idx !== index);
		this.handleEmailValidityCheck(emails);
		this.props.setReportProperties({emails: emails});
	};

	handleEditEmail = (emailObj) => {
		let emails = [...this.props.emails];
		if(emails[emailObj.index] !== undefined) {
			emails[emailObj.index] = {value: emailObj.value, valid: emailObj.valid};
		}
		this.handleEmailValidityCheck(emails);
		this.props.setReportProperties({emails: emails});
	};

	renderEmailList = () => (
		<div className={`email-list`} ref={div => this.emailListDiv = div}>
			<Title size={`small`}>
				<h4>Send to these addresses</h4>
			</Title>
			<AddableEmailList emails={this.props.emails} addEmail={this.handleAddEmail} removeEmail={this.handleRemoveEmail} editEmail={this.handleEditEmail}/>
		</div>
	);

	render() {
		return(
			<Area name={`schedule`}
				  klass={`${this.props.classes.schedule}`}
				  title={`Schedule`}
				  tooltip={<p>Schedule your report to arrive automatically in your inbox</p>}>
				<Group direction={`horizontal`}>
					{this.renderScheduleTypeList()}
					{(this.props.schedule !== 'ONCE') && this.renderScheduleOptionList()}
				</Group>
			</Area>
		);
	}

}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ReportSchedule);
